import { render, staticRenderFns } from "./OrdersContacts.vue?vue&type=template&id=701309ac&"
import script from "./OrdersContacts.vue?vue&type=script&lang=js&"
export * from "./OrdersContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports